import { createSlice } from '@reduxjs/toolkit';
import { incidentsApi } from '../functions/IncidentsApi';

const initialState = {
  chartsData: {},
  loading: false,
};

export const incidentsPerformanceReducer = createSlice({
  name: 'incidentsReducer',
  initialState,
  reducers: {
    setChartsData: (state, action) => {
      state.chartsData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setChartsData, setLoading } =
  incidentsPerformanceReducer.actions;

export default incidentsPerformanceReducer.reducer;

export const getIncidentsOverview =
  ({ start_dt, end_dt, department }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await incidentsApi.getIncidentsOverview({
        start_dt,
        end_dt,
        department
      });

      if (response.status === 200) {
        dispatch(setChartsData(response.data));
      } else throw new Error('No data received from API');
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLoading(false));
    }
  };
